import { OrderStatus } from "@/types/order";
import { Badge } from "@/components/ui/badge";
import { getStatusVariant, orderStatuses } from "@/utils/orderUtils";

interface OrderStatusBadgeProps {
  status: OrderStatus;
  className?: string;
}

export function OrderStatusBadge({ status, className }: OrderStatusBadgeProps) {
  return (
    <Badge variant={getStatusVariant(status)} className={className}>
      {orderStatuses[status]}
    </Badge>
  );
}
